<!-- Sidebar toggle icons -->
@if (!isHomeHeader) {
  <div nz-flex [nzJustify]="'flex-start'" [nzAlign]="'center'" [nzGap]="'10px'">
    <nz-icon
      class="trigger d-none d-md-block"
      [nzType]="isCollapsed ? 'menu-unfold' : 'menu-fold'"
      (click)="handleToggle()"
    ></nz-icon>
    @if (!isHomeHeader) {
      <div class="d-md-none">
        <button
          nz-button
          type="button"
          class="mobile-menu-button"
          (click)="visible = true"
          aria-label="Open menu"
        >
          <nz-icon nzType="menu-unfold" nzTheme="outline"></nz-icon>
        </button>
      </div>
    }
    <a
      [routerLink]="homeRoute"
      class="border-0"
      style="color: gray; font-size: 14px; line-height: 1.5"
    >
      <i class="fa-solid fa-house" style="font-size: 16px"></i>
      <p class="d-none d-md-inline ms-2">Back to Home</p>
    </a>
  </div>
}

@if (visible) {
  <div class="mobile-sidebar-backdrop" (click)="closeMenuPopup()"></div>

  <aside class="custom-mobile-sidebar" [class.sidebar-open]="visible">
    <div class="mobile-sidebar-header">
      <div class="mobile-sidebar-logo">
        <img src="images/logo.png" alt="Veta Investment Partners" />
      </div>

      <button
        nz-button
        nzType="text"
        type="button"
        class="mobile-sidebar-close"
        (click)="closeMenuPopup()"
      >
        <nz-icon nzType="close" nzTheme="outline"></nz-icon>
      </button>
    </div>

    <div class="mobile-sidebar-body">
      <ul class="mobile-sidebar-menu">
        @for (detail of sideBarlist; track detail) {
          <li
            class="mobile-sidebar-item"
            [class.active]="isActive(detail.path)"
            [routerLink]="detail.path"
            (click)="closeMenuPopup()"
          >
            <span class="mobile-sidebar-icon">
              <i class="{{ detail.icon }}"></i>
            </span>

            <span class="mobile-sidebar-title">
              {{ detail.title }}
            </span>
          </li>
        }
      </ul>
    </div>
  </aside>
}

@if (!isHomeHeader) {
  <div class="search-container mx-1 w-25 position-relative">
    @if (isSearchVisible) {
      <nz-input-search class="rounded">
        <input
          nz-input
          placeholder="Search"
          [(ngModel)]="search"
          (ngModelChange)="onInputChange($event)"
          (focus)="onInputFocus()"
          autocomplete="off"
        />
      </nz-input-search>
    }

    @if (showSuggestions && search) {
      <div
        class="suggestion-popup bg-white border rounded shadow-sm w-100 position-absolute mt-1 z-1000"
      >
        @if (searchLoader) {
          <div>
            <div class="p-4" nz-flex nzJustify="center" nzAlign="center">
              <app-loader></app-loader>
            </div>
          </div>
        }
        @if (!searchLoader) {
          @if (searchResults.length > 0) {
            <div>
              <nz-list nzBordered class="custom-list">
                @for (item of searchResults; track item) {
                  <nz-list-item
                    class="py-2 px-2"
                    style="font-size: 13px; cursor: pointer"
                    (click)="selectSuggestion(item)"
                  >
                    {{ item?.search_string }}
                  </nz-list-item>
                }
              </nz-list>
            </div>
          }
          @if (searchResults.length === 0) {
            <div class="p-2 text-muted text-center">No results found</div>
          }
        }
      </div>
    }
  </div>
}

@if (isHomeHeader) {
  <div nz-flex nzJustify="flex-start" nzAlign="center" [nzGap]="'20px'">
    <a class="full-width-link" [routerLink]="">
      <img src="images/logo.png" alt="Matrix Logo" width="100" height="auto" />
    </a>
    @if (isProfilePage) {
      <a
        [routerLink]="homeRoute"
        class="border-0"
        style="color: gray; font-size: 14px; line-height: 1.5"
      >
        <i class="fa-solid fa-house" style="font-size: 16px"></i>
        <p class="d-none d-md-inline ms-2">Back to Home</p>
      </a>
    }
  </div>
}
<div nz-flex [nzJustify]="'flex-start'" [nzAlign]="'center'" [nzGap]="'10px'">
  @if (isInsuranceActive) {
    <div>
      <div nz-dropdown [nzDropdownMenu]="userMenu" nzTrigger="click">
        <button
          nz-button
          nzSize="small"
          nzType="primary"
          class="btn-primary-danger me-0"
          [ngStyle]="{ border: 'none' }"
        >
          <span>{{ user }} </span>
        </button>
      </div>
      <nz-dropdown-menu #userMenu="nzDropdownMenu" class="user-menu">
        <ul nz-menu class="d-inline-block common-header-menu">
          @for (item of userTypeList; track item) {
            <li
              nz-menu-item
              class="flex items-center gap-2"
              (click)="onSelectionChange(item.value)"
            >
              <span>{{ item.label }} </span>
            </li>
          }
        </ul>
      </nz-dropdown-menu>
    </div>
  }

  @if (moduleNameWithColor.label) {
    <div
      class="btn-primary me-0 px-2"
      [ngStyle]="{
        height: '24px',
        backgroundColor: moduleNameWithColor.color,
        cursorPointer: 'none! important',
        border: 'none',
        lineHeight: '24px',
      }"
    >
      <span>{{ moduleNameWithColor.label }} </span>
    </div>
  }
</div>
<div nz-flex nzJustify="flex-end" nzAlign="center">
  <shared-user-menu></shared-user-menu>
</div>
